import { Component, OnInit } from '@angular/core';
import { FileModel } from 'src/app/core/models/shared/file.model';
import { ViewSDKClient } from 'src/app/core/services/viewSDKClient.service';

@Component({
  selector: 'app-manual-pdf-a',
  templateUrl: './manual-pdf-a.component.html',
  styleUrls: ['./manual-pdf-a.component.scss']
})
export class ManualPDFAComponent implements OnInit {

  fileUrl: FileModel = new FileModel
  constructor(
    private viewSDKClient: ViewSDKClient 
  ) { }   
  
  ngOnInit(): void {
    // this.getData();
  }

  async getData() {

    this.renderPDf()
    // this.innerHtml = this.sanitized.bypassSecurityTrustHtml(
    //   "<embed src='" + this.fileUrl.url + '#page=1&zoom=100'+ "' type='application/pdf' height='700px' width='100%'>");
  }
  renderPDf() {
    this.viewSDKClient.ready().then(() => {
      /* Invoke file preview */
      const canvas: any = document.querySelector('#pdf-div');
      canvas.style.display = "block";
      canvas.style.height = "100vh";
      let defConfg = {
        showAnnotationTools: false, 
        showPageControls: true, 
        showDownloadPDF: true, 
        showPrintPDF: true
        // defaultViewMode: "FIT_WIDTH"
      }
      //this.viewSDKClient.previewFile('pdf-div', defConfg, this.fileUrl.url,'');
      this.viewSDKClient.previewFile('pdf-div', defConfg,'assets/doc/PDF-A_manual.pdf','');
    });
  }
}
